import { Injector, Provider, inject } from '@angular/core';

import {
  LOCAL_STORE_FACTORY,
  LocalStoreFactory,
  OFFLINE_PULL_FACTORY,
  OfflinePullFactory,
} from '../adapter/offline-adapter.ports';

/**
 * kzd of2 P2-11: the offline runtime's platform bindings, in the app's providers (docs/kz-offline/PLAN-P2.md §3 P2-11;
 * P2-R12). EAGER and tiny on purpose: each binding is an object whose one method loads `device-binding.ts` — and with it
 * the platform hosts (P2-3b), the SQLite pull log and the pull feed (P2-9) — only when the lazy runtime asks, which it
 * does only on a native start that resolved offline (the web, the mock, stage and prod never load it). They load it
 * through the offline runtime's own chunk (`offline-runtime.ts` re-exports it): ONE lazy entry for all offline code, so
 * the bundler does not split the code it shares with the app into more initial chunks.
 *
 * - `LOCAL_STORE_FACTORY` → the platform's store, op log and pull log, ONE database per business (`deviceStoreName`);
 * - `OFFLINE_PULL_FACTORY` → P2-9's `PullFeed` over `FirebasePullSource` and that pull log, opened.
 */
export const offlineBindingProviders: Provider[] = [
  {
    provide: LOCAL_STORE_FACTORY,
    useValue: {
      open: (input) => import('../adapter/offline-runtime').then((m) => m.openDeviceLocalStore(input)),
    } satisfies LocalStoreFactory,
  },
  {
    provide: OFFLINE_PULL_FACTORY,
    useFactory: (): OfflinePullFactory => {
      const injector = inject(Injector);
      return {
        create: (input) => import('../adapter/offline-runtime').then((m) => m.createDevicePullFeed(input, injector)),
      };
    },
  },
];
